/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { Link as RouterLink } from 'react-router-dom';

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";

// Pagina principal page sections
import Information from "pages/PaginaPrincipal/sections/Information";
import Testimonials from "pages/PaginaPrincipal/sections/Testimonials";
import AboutUs from "pages/PaginaPrincipal/sections/AboutUs";
import SolucoesSec from "pages/PaginaPrincipal/sections/Solucoes";
import Clientes from "layouts/sections/page-sections/logo-areas/components/FMPLogoAreaOne"; 
import NossasNovidades from "pages/PaginaPrincipal/sections/Newsletter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg_home.jpg";

function PaginaPrincipal() {
   
  const scrollToAboutUs = () => {
    const section = document.getElementById("about-us");
    section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/ajuda/contate-nos",
          label: "Contate-nos",
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.5),
              rgba(gradients.dark.state, 0.5)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            md={7}
            justifyContent={{ xs: "center", md: "start" }}
            sx={{ textAlign: { xs: "center", md: "left" } }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              FMP Soluções
            </MKTypography>
            <MKTypography
              variant="h5"
              color="white"
              mt={1}
              pr={{ md: 12, lg: 24, xl: 12 }}
              opacity={0.8}
            >
              Soluções cibernéticas sob medida para ambientes de alta segurança — tecnologia proprietária 
              para proteger empresas, governos e forças de segurança.

            </MKTypography>
            <Stack direction="row" spacing={1} mt={6} mb={3}>
              <MKButton 
                variant="gradient" 
                color="info"
                component={RouterLink}
                to="/pages/ajuda/contate-nos"
              >
                Contate-nos
              </MKButton>
              <MKButton 
              variant="text" 
              color="white"
              onClick={scrollToAboutUs} >
                Saiba mais
              </MKButton>
            </Stack>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Information />
        <AboutUs id="about-us"/>
        <SolucoesSec /> 
        <br /> <br />
        <Testimonials />
        <Clientes />
        <NossasNovidades />
        
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default PaginaPrincipal;
